<template>
  <div>
    <div class="head_box flex_start flex_center_align">
      <svg-icon icon-class="edit_2_line"></svg-icon>
      <span class="hd_title">
        <slot name="hd_title">報告書一覧</slot>
      </span>
    </div>
    <div class="h_date">
      <span class="h_title">
        <slot name="h_title">書類の提出を行ってください</slot>
      </span>
    </div>
    <div class="file_box">
      <vab-row class="row_box gray">
        <vab-col :span="4" class="boxleft"></vab-col>
        <vab-col :span="9" class="boxleft ht">
          アップロードされたファイル
        </vab-col>
        <vab-col :span="1" class="boxleft"></vab-col>
        <vab-col :span="10" class="boxleft ht">確認用ファイル</vab-col>
      </vab-row>
      <vab-row v-for="(item, index) in fileList" :key="index" class="row_box">
        <vab-col :span="4" class="boxleft gray flex_center_align">
          <div class="flex_colum">
            <div>
              {{ item.name }}
              <i class="red">*</i>
            </div>
            <vab-upload></vab-upload>
          </div>
        </vab-col>
        <vab-col :span="9" class="boxleft cpading">
          <div v-if="index != 3" class="percent">
            <div v-for="son in 2" :key="son" class="inner_box flex_colum">
              <span class="fname">エスティーム株式会社</span>
              <div class="file_link">
                〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇{{ item.name }}.xlsx
              </div>
              <div class="flex_start ftime_box flex_center_align">
                <span class="time_word">最終更新日時：2022/09/01 13:55</span>
                <div class="de_box">削除</div>
              </div>
            </div>
          </div>
          <div v-else class="no_file">ファイルがありません</div>
        </vab-col>
        <vab-col :span="1" class="boxleft flex_center_align flex_center">
          <img src="~@/assets/images/file_icon.png" alt="" />
        </vab-col>
        <vab-col :span="10" class="boxleft">
          <div v-if="index != 3">
            <!-- <div class="inner_box flex_colum gray boxradio">
              <span class="fname">エスティーム株式会社</span>
              <div class="file_link nobox">
                〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇工事完了報告書.xlsx
              </div>
            </div> -->
            <template v-if="$attrs.type == 1">
              <div class="flex_start flex_end er_box">
                <div cclass="img_box2">
                  <img
                    class="common_img"
                    src="~@/assets/images/r11.png"
                    alt=""
                  />
                </div>
                <span class="state_word red">差し戻し</span>
              </div>
              <div class="flex_end er_box">
                <div
                  class="flex_start er_box_inner flex_center_align flex_center blue change_blue"
                >
                  <div cclass="img_box2">
                    <img
                      class="common_img"
                      src="~@/assets/images/r10.png"
                      alt=""
                    />
                  </div>
                  <span class="state_word blue">提出済み</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="flex_end er_box">
                <div
                  class="flex_start er_box_inner flex_center_align flex_center"
                >
                  <div cclass="img_box2">
                    <img
                      class="common_img"
                      src="~@/assets/images/r11.png"
                      alt=""
                    />
                  </div>
                  <span class="state_word error">差し戻し</span>
                </div>
              </div>
              <div class="flex_end er_box">
                <div
                  class="flex_start er_box_inner flex_center_align flex_center blue"
                >
                  <div cclass="img_box2">
                    <img
                      class="common_img"
                      src="~@/assets/images/r10.png"
                      alt=""
                    />
                  </div>
                  <span class="state_word blue">確認</span>
                </div>
              </div>
            </template>
            <!-- <div class="flex_end er_box">
              <vab-checkbox label="ファイルを協力会社に連携" />
            </div> -->
          </div>
        </vab-col>
      </vab-row>
    </div>
    <div class="bs_btn_main m12">
      <vab-button :btn-list="btnList"></vab-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabFile',
    props: {
      nofile: {
        type: Boolean,
        default: false,
      },
      tc: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        fileList: [
          { name: '見積書' },
          { name: '提案書' },
          { name: 'アスベスト関連' },
          { name: '少量産廃報告書' },
        ],
        btnList: [
          {
            name: ' 提出催促',
            icon: 'mail_send_line',
            msg: 'アップロードされていないすべての書類の提出を催促します。よろしいですか？',
            word: '書類の提出催促が完了しました。',
            type: 'plain',
            hover: '#0171EE',
            msgOk: 'ok',
            defaultColor: '#0060C2',
            hidden: true,
            click: (row) => {
              this.msgSuccess(row.word)
            },
          },
          {
            name: ' 確認用ファイルを一括ダウンロード',
            widht: 'auto',
            icon: 'down',
            word: '保存しました',
            type: 'plain',
            hover: '#0171EE',
            defaultColor: '#0060C2',
            hidden: false,
            click: (row) => {
              this.msgSuccess(row.word)
            },
          },
        ],
      }
    },
    mounted() {
      if (this.$attrs.type != 1) {
        this.btnList[0].hidden = false
      }
    },
    methods: {},
  }
</script>

<style lang="scss" scoped></style>
